import { render, staticRenderFns } from "./brandModal.vue?vue&type=template&id=1a65df1c&scoped=true&"
import script from "./brandModal.vue?vue&type=script&lang=js&"
export * from "./brandModal.vue?vue&type=script&lang=js&"
import style0 from "./brandModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./brandModal.vue?vue&type=style&index=1&id=1a65df1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65df1c",
  null
  
)

export default component.exports